import { useCallback, useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Overview } from "./dashboard/Overview";
import { Reports } from "./dashboard/Reports";
import { Profile } from "./dashboard/Profile";
import { Tracks } from "./dashboard/Tracks";
import { PlanTab } from "./dashboard/PlanTab";
import { Cards } from "./dashboard/Cards";
import { Bookings } from "./dashboard/Bookings";
import { Insights } from "./dashboard/Insights";
import { Events } from "./dashboard/Events";

const TABS = [["overview", "Overview"], ["reports", "Play reports"], ["insights", "Insights"], ["profile", "Profile"], ["tracks", "Tracks"], ["events", "Events"], ["plan", "Plan & services"], ["cards", "Story cards"], ["bookings", "Bookings"]];

export default function Dashboard() {
  const { user, refreshMe } = useAuth();
  const [params] = useSearchParams();
  const [d, setD] = useState(null);
  const [tab, setTab] = useState(params.get("tab") || "overview");
  const load = useCallback(async () => {
    const { data } = await api.get("/me/dashboard");
    setD(data);
    refreshMe();
    return data;
  }, [refreshMe]);
  useEffect(() => { if (user) load(); }, [user?.id]); // eslint-disable-line
  useEffect(() => { const t = params.get("tab"); if (t) setTab(t); }, [params]);

  if (user === false) return <Navigate to="/login" />;
  if (user?.role === "admin") return <Navigate to="/admin" />;
  if (!d) return <div className="pt-40 text-center font-mono text-slate-500">Loading your studio…</div>;
  const props = { d, reload: load, go: setTab };
  return (
    <div className="mx-auto max-w-7xl px-4 pb-32 pt-24 md:px-8" data-testid="dashboard-page">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="label-mono">Artist studio</div>
          <h1 className="mt-2 font-display text-4xl font-black uppercase sm:text-5xl" data-testid="dashboard-stage-name">{d.user.stage_name}</h1>
        </div>
        <span className="rounded-full border border-[#00F5D4]/50 px-4 py-1.5 font-mono text-xs uppercase tracking-widest text-[#00F5D4]" data-testid="dashboard-plan-badge">{d.plan.name} plan</span>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="no-scrollbar mb-8 flex h-auto w-full justify-start gap-1 overflow-x-auto rounded-full border border-white/10 bg-[#0F1420] p-1">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`dash-tab-${v}`} className="shrink-0 rounded-full px-4 py-2 font-mono text-[11px] uppercase tracking-widest data-[state=active]:bg-[#FF2E63] data-[state=active]:text-white">{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="overview"><Overview {...props} welcome={params.get("welcome")} /></TabsContent>
        <TabsContent value="reports"><Reports {...props} /></TabsContent>
        <TabsContent value="insights"><Insights {...props} /></TabsContent>
        <TabsContent value="profile"><Profile {...props} /></TabsContent>
        <TabsContent value="tracks"><Tracks {...props} /></TabsContent>
        <TabsContent value="events"><Events {...props} /></TabsContent>
        <TabsContent value="plan"><PlanTab {...props} /></TabsContent>
        <TabsContent value="cards"><Cards {...props} /></TabsContent>
        <TabsContent value="bookings"><Bookings /></TabsContent>
      </Tabs>
    </div>
  );
}
